export default function queryParams(queryObject: Object = {}, path: string) {
    let rlt = `${path}?`
    for (const [key, value] of Object.entries(queryObject)) {
        if (Array.isArray(value)) {
            let rlt_ = ''
            value.forEach((item) => {
                rlt_ += `${key}=${item}&`
            })
            rlt += rlt_
        } else {
            rlt += `${key}=${value}&`
        }
    }

    return rlt
}
